module.exports = __webpack_public_path__ + "media/images/qr/audiobook-qr-mono-eb23a92e46855438a97f74d22c4dce6c.svg";